import Script from 'next/script';

import { parseToBool } from 'lib/string';
import { markup } from 'lib/utils';

import APP from 'constants/app';

const MouseflowScriptTag = () => {
  if (!parseToBool(process.env.NEXT_PUBLIC_MOUSEFLOW_ENABLED)) {
    return null;
  }

  return (
    <Script
      id="mouseflow-script-url"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={markup(`
        window._mfq = window._mfq || [];
        (function() {
          var mf = document.createElement("script");
          mf.type = "text/javascript"; mf.defer = true;
          mf.src = "${APP.MOUSEFLOW_URL}${process.env.NEXT_PUBLIC_MOUSEFLOW_ID}.js";
          document.getElementsByTagName("head")[0].appendChild(mf);
        })();
      `)}
    />
  );
};

export default MouseflowScriptTag;
